import Constant from '@/lib/constant';

const baseRole = Constant.RoleList;

const layout = () => import(/* webpackChunkName:'p_layout' */ '../layout/index.vue');
const supervisionOrder = () => import(/* webpackChunkName:'p_supervision' */ '@/pages/supervision/orderList');
const supervisionSpecialOrder = () =>
  import(/* webpackChunkName:'p_supervision' */ '@/pages/supervision/specialOrderList');
const supervisionPrescriptionOrder = () =>
  import(/* webpackChunkName:'p_supervision' */ '@/pages/supervision/prescriptionOrderList');
const supervisionCatalogue = () =>
  import(/* webpackChunkName:'p_supervision_catalogue' */ '@/pages/supervision/catalogueList');
const supervisionSpecialCatalogue = () =>
  import(/* webpackChunkName:'p_supervision_special_catalogue' */ '@/pages/supervision/specialCatalogue');
const registrationRecordListEpi = () =>
  import(/* webpackChunkName:'p_registration_record_list_epi' */ '@/pages/registrationRecord/epiEntry');
const registrationRecordListNar = () =>
  import(/* webpackChunkName:'p_registration_record_list_nar' */ '@/pages/registrationRecord/specialEntry');

const registrationRecordIvDetail = () =>
  import(/* webpackChunkName:'p_registration_record_detail' */ '@/pages/registrationRecord/classIvDetail');
const registrationRecordSpecialDetail = () =>
  import(/* webpackChunkName:'p_registration_record_special_detail' */ '@/pages/registrationRecord/classSpecialDetail');
const pharmacistSupervisionList = () =>
  import(/* webpackChunkName:'p_pharmacist_supervision_list' */ '@/pages/pharmacistSupervision/list');
const inventorySupervisionSale = () =>
  import(/* webpackChunkName:'p_inventory_supervision_sale' */ '@/pages/inventorySupervision/sale');
const inventorySupervisionStock = () =>
  import(/* webpackChunkName:'p_inventory_supervision_stock' */ '@/pages/inventorySupervision/stock');
const inventorySupervisionLaidUp = () =>
  import(/* webpackChunkName:'p_inventory_supervision_laid_up' */ '@/pages/inventorySupervision/laidUp');
const prescriptionSupervisionList = () =>
  import(/* webpackChunkName:'p_supervision' */ '@/pages/supervision/prescriptionSupervisionList');
const prescriptionSupervisionDetail = () =>
  import(/* webpackChunkName:'p_supervision' */ '@/pages/supervision/prescriptionSupervisionDetail');
const messageCenter = () => import(/* webpackChunkName:'p_messageCenter' */ '@/pages/messageCenterForSupervision');

export default [
  {
    path: '/supervision-order',
    component: layout,
    name: 'supervision-order',
    children: [
      {
        path: '',
        name: 'supervisionOrder',
        component: supervisionOrder,
        meta: {
          title: '四类药品销售订单',
          belong: '/supervision-order',
          trackId: 'zywzpc-page-supervision'
        }
      }
    ],
    meta: {
      title: '四类药品销售订单',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/supervision-special-order',
    component: layout,
    name: 'supervision-special-order',
    children: [
      {
        path: '',
        name: 'supervisionSpecialOrder',
        component: supervisionSpecialOrder,
        meta: {
          title: '特殊药品销售订单',
          belong: '/supervision-special-order',
          trackId: 'zywzpc-page-special-supervision'
        }
      }
    ],
    meta: {
      title: '特殊药品销售订单',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/supervision-prescription-order',
    component: layout,
    name: 'prescription-order',
    children: [
      {
        path: '',
        name: 'supervisionPrescriptionOrder',
        component: supervisionPrescriptionOrder,
        meta: {
          title: '处方药品销售订单',
          belong: '/supervision-prescription-order',
          trackId: 'zywzpc-page-prescription-supervision'
        }
      }
    ],
    meta: {
      title: '处方药品销售订单',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/supervision-catalogue',
    component: layout,
    name: 'supervision-catalogue',
    children: [
      {
        path: '',
        name: 'supervision-catalogue-list',
        component: supervisionCatalogue,
        meta: {
          title: '四类药品目录',
          belong: '/supervision-catalogue',
          trackId: 'zywzpc-page-supervision'
        }
      }
    ],
    meta: {
      title: '四类药品目录',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/supervision-special-catalogue',
    component: layout,
    name: 'supervision-special-catalogue',
    children: [
      {
        path: '',
        name: 'supervision-special-catalogue',
        component: supervisionSpecialCatalogue,
        meta: {
          title: '特殊药品目录',
          belong: '/supervision-special-catalogue',
          trackId: 'zywzpc-page-supervision-special-catalogue'
        }
      }
    ],
    meta: {
      title: '特殊药品目录',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/registration-list-epi',
    component: layout,
    name: 'registration',
    children: [
      {
        path: '',
        name: 'registrationListEpi',
        component: registrationRecordListEpi,
        meta: {
          title: '四类药品登记记录',
          belong: '/registration-list-epi',
          trackId: 'zywzpc-page-registration'
        }
      },
      {
        path: 'detail',
        name: 'registrationDetail',
        component: registrationRecordIvDetail,
        meta: {
          title: '登记记录详情',
          belong: '/registration-list-epi',
          trackId: 'zywzpc-page-registration'
        }
      }
    ],
    meta: {
      title: '四类药品登记记录',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/registration-list-nar',
    component: layout,
    name: 'registration',
    children: [
      {
        path: '',
        name: 'registrationListNar',
        component: registrationRecordListNar,
        meta: {
          title: '特殊药品登记记录',
          belong: '/registration-list-nar',
          trackId: 'zywzpc-page-registration'
        }
      },
      {
        path: 'detail',
        name: 'registrationDetail',
        component: registrationRecordIvDetail,
        meta: {
          title: '登记记录详情',
          belong: '/registration-list-nar',
          trackId: 'zywzpc-page-registration'
        }
      },
      {
        path: 'special-detail',
        name: 'registrationSpecialDetail',
        component: registrationRecordSpecialDetail,
        meta: {
          title: '登记记录详情',
          belong: '/registration-list',
          trackId: 'zywzpc-page-registration'
        }
      }
    ],
    meta: {
      title: '特殊药品登记记录',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/pharmacist-supervision',
    component: layout,
    name: 'pharmacistSupervision',
    children: [
      {
        path: '',
        name: 'pharmacistSupervisionList',
        component: pharmacistSupervisionList,
        meta: {
          title: '执业药师列表',
          belong: '/pharmacist-supervision',
          trackId: 'zywzpc-page-pharmacist-supervision'
        }
      }
    ],
    meta: {
      title: '执业药师列表',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/inventory-supervision-laid-up',
    component: layout,
    name: 'inventorySupervisionLaidUp',
    children: [
      {
        path: '',
        name: 'inventorySupervisionLaidUp',
        component: inventorySupervisionLaidUp,
        meta: {
          title: '入库记录',
          belong: '/inventory-supervision-laid-up',
          trackId: 'zywzpc-page-inventory-supervision'
        }
      }
    ],
    meta: {
      title: '进销存入库记录',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/inventory-supervision-stock',
    component: layout,
    name: 'inventorySupervisionStock',
    children: [
      {
        path: '',
        name: 'inventorySupervisionStock',
        component: inventorySupervisionStock,
        meta: {
          title: '库存统计',
          belong: '/inventory-supervision-stock',
          trackId: 'zywzpc-page-inventory-supervision'
        }
      }
    ],
    meta: {
      title: '进销存库存统计',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/inventory-supervision-sale',
    component: layout,
    name: 'inventorySupervisionSale',
    children: [
      {
        path: '',
        name: 'inventorySupervisionSale',
        component: inventorySupervisionSale,
        meta: {
          title: '特殊药品登记记录',
          belong: '/inventory-supervision-sale',
          trackId: 'zywzpc-page-inventory-supervision'
        }
      }
    ],
    meta: {
      title: '进销存销售订单',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/prescription-supervision',
    component: layout,
    name: 'prescription-supervision',
    children: [
      {
        path: '',
        name: 'prescription-supervision-list',
        component: prescriptionSupervisionList,
        meta: {
          title: '处方列表',
          belong: '/prescription-supervision',
          trackId: 'zywzpc-page-prescription-supervision'
        }
      },
      {
        path: 'detail',
        name: 'prescription-supervision-detail',
        component: prescriptionSupervisionDetail,
        meta: {
          title: '处方详情',
          belong: '/prescription-supervision',
          trackId: 'zywzpc-page-prescription-supervision-detail'
        }
      }
    ],
    meta: {
      title: '处方记录',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/messageCenterForSupervision',
    component: layout,
    children: [
      {
        path: '',
        name: 'messageCenter',
        component: messageCenter,
        meta: {
          title: '消息中心',
          roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f, baseRole.g]
        }
      }
    ],
    meta: {
      title: '消息中心',
      hide: true,
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f, baseRole.g]
    }
  }
];
